import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import '../../../scss/app.scss';
import "react-toggle/style.css";
import { Bill } from '../../Shared/Bill';
import { formatMoney } from '../../Shared/Functions';
import { Button, Card, CardContent, Divider, Grid } from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { AlertTypeEnum, BillingAccountStatusEnum } from '../../../services/V2/gozer';
import DOMPurify from 'dompurify';

export function RecentBill({ account, lastPayment, bill, recurring, fail }) {
    const history = useHistory();
    const [showMostRecentBill, setShowMostRecentBill] = useState<boolean>(false);
    const [alertMessage, setAlertMessage] = useState<any>(null);

    useEffect(() => {
        setAlertMessage(account?.alertMessages?.find(x => x.alertType === alertType()))
    }, [account])// eslint-disable-line react-hooks/exhaustive-deps

    const alertType = () => {
        switch (account.status){
            case BillingAccountStatusEnum.BANKRUPTCY:
                return AlertTypeEnum.BANKRUPTCY;
            case BillingAccountStatusEnum.CUTOFF:
                return AlertTypeEnum.CUTOFF;
            case BillingAccountStatusEnum.COLLECTION_LIST:
                return AlertTypeEnum.COLLECTION_LIST;
            case BillingAccountStatusEnum.DELINQUENT:
                return AlertTypeEnum.DELINQUENT;
            case BillingAccountStatusEnum.DOOR_TAG:
                return AlertTypeEnum.DOOR_TAG;
            case BillingAccountStatusEnum.WRITE_OFF:
                return AlertTypeEnum.WRITE_OFF;
        }
    }

    const showBill = () => {
        setShowMostRecentBill(true)
    }

    const sanitizedAlert = () => ({
        __html: DOMPurify.sanitize(alertMessage.message),
    });

    return (<>
        {showMostRecentBill && <Bill show={showMostRecentBill} hide={() => setShowMostRecentBill(false)} billingAccountId={account.id} billId={bill?.id} fail={fail} />}
        <Card className='bill-card'>
            <CardContent>
                <p>
                    <Grid style={{marginRight: "15px", marginLeft: "15px"}}>
                        <Grid className='bill-card-grid'>
                            <Grid style={{display: "flex", flexDirection: "column", flex: "1"}}>
                                <Grid style={{fontSize: "1.4em", fontWeight: "400"}}><b>Account Balance</b></Grid>
                                <Grid
                                    className="align-bottom"
                                    style={{
                                        fontSize: '3.5rem',
                                        fontWeight: '400'
                                    }}>{formatMoney(account.amountDue)}
                                </Grid>
                                {lastPayment ?
                                    <Grid>
                                        <p>Last payment of
                                            <span style={{ color: "#2d4a29" }}> {formatMoney(lastPayment.amount.toFixed(2))}</span> made on
                                            <span style={{ color: "#2d4a29" }}> {lastPayment.date?.toLocaleDateString()}</span>
                                        </p>
                                    </Grid>
                                : 
                                    <Grid className="text-muted">
                                        <i>No recent payment activity...</i>
                                    </Grid>
                                }
                                {account?.dueDate &&
                                    <>
                                        <Grid style={{width: "100%", fontSize: "1.1em"}}>
                                            <Grid><b>Payment Due: {(new Date(account.dueDate)).toLocaleDateString()}</b></Grid>
                                        </Grid>
                                    </>
                                }
                            </Grid>
                            <Grid className='recent-bill-buttons-group'>
                                <Button className='recent-bill-button' variant="contained" color="primary" onClick={() => history.push('/payment')}>Make Payment</Button>
                                <Button className='recent-bill-button' variant="outlined" color="primary" onClick={showBill}>View Bill</Button>
                                <Button className='recent-bill-button' variant="outlined" color="primary" onClick={() => history.push('/history')}>View Account History</Button>
                            </Grid>
                        </Grid>
                        <Divider style={{ margin: "20px 0px" }} />
                        <Grid>
                            {account?.pastDueAmount > 0 &&
                                <>
                                    <Grid style={{ fontSize: "15px", color: "#990000", width: "100%", marginBottom: "20px" }}>
                                        <Grid>Past Due Amount: {formatMoney(account.pastDueAmount)}</Grid>
                                    </Grid>
                                </>
                            }
                            {alertMessage &&
                                <Grid style={{ width: "100%", marginBottom: "20px" }}>
                                    <div dangerouslySetInnerHTML={sanitizedAlert()} style={{ color: "#990000", fontSize: "15px", margin: "0px" }} />
                                </Grid>
                            }
                            {recurring &&
                                <Grid style={{ fontSize: "15px" }}>
                                    <AutorenewIcon style={{ maxHeight:"15px" }} />
                                    <i>Account is enrolled in AutoPay. Your payment will be automatically processed for the amount due.</i>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </p>
            </CardContent>
        </Card>
        </>)

}
